import React, { useState, useEffect } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import { Modal } from '@material-ui/core'
import { useStyles } from './MaterialUiModal'
// import BootstrapAlert from './element/BootstrapAlert'
import ErrorBoundary from './ErrorBoundary'

export default function ConfirmModal (props) {
  const classes = useStyles()
  const [modalOpen, setModalOpen] = useState(false)

  useEffect(() => {
  }, [])

  return (
    <>
      <button className="btn btn-danger" onClick={(e) => setModalOpen(true)}>{props.textSubmit}</button>
      <Modal
        className={classes.modal}
        open={modalOpen}
        onClose={() => setModalOpen(false)}>
        <div className={classes.paper}>
          <h2>{props.textHeader}</h2>
          <hr />
          {props.textBodyLines.map((line, i) => (
            <div key={i}>{line}<br></br></div>
          ))}
          <hr />
          <div className="row theme-3">
            <div className="col-6">
              <button type='button' className='btn btn-outline-secondary' onClick={() => { setModalOpen(false) }}>
                キャンセル
              </button>
            </div>
            <div className="col-6 text-right">
              <form action={props.postUrl} method="post">
                <input type="text" name="_token" className="d-none" readOnly value={$('meta[name="csrf-token"]').attr('content')} />
                <button type='submit' className='btn btn-danger' onClick={(e) => { window.onbeforeunload = null }}>
                  {props.textSubmit}
                </button>
              </form>
            </div>
          </div>
        </div>
      </Modal>
    </>

  )
}

ConfirmModal.propTypes = {
  postUrl: PropTypes.string,
  textHeader: PropTypes.string,
  textBodyLines: PropTypes.arrayOf(PropTypes.string),
  textSubmit: PropTypes.string
}

document.querySelectorAll('.confirm-modal').forEach((el) => {
  const props = Object.assign({}, el.dataset)
  props.textHeader = el.querySelector('.confirm-modal-header').innerText
  props.textBodyLines = Array.from(
    el.querySelectorAll('.confirm-modal-body'),
    (lineEl) => lineEl.innerText
  )
  props.textSubmit = el.querySelector('.confirm-modal-submit').innerText

  ReactDOM.render(
    <ErrorBoundary>
      <ConfirmModal {...props}/>
    </ErrorBoundary>,
    el
  )

  Object.keys(props).map((key) => { // ソースにdata-属性が残らないように削除
    el.removeAttribute('data-' + key.replace(/[A-Z]/g, (s) => '-' + s.charAt(0).toLowerCase()))
    return 0
  })
})
